import { NeedDto, UserDto } from '@act/shared/data-transfer-objects';
import { timeFormatter } from '@act/shared/utilities';

export enum NeedStatus {
  Fulfilled = 'Fulfilled',
  Identified = 'Identified',
  StoppedPursuing = 'Stopped pursuing',
  Unresolved = 'Unresolved',
}

export function getNeedStatus(need: NeedDto, member: UserDto): NeedStatus {
  if (need.fulfilledAt) {
    return NeedStatus.Fulfilled;
  }

  if (need.abandonedAt) {
    return NeedStatus.StoppedPursuing;
  }

  if (needIsUnresolved(need, member)) {
    return NeedStatus.Unresolved;
  }

  return NeedStatus.Identified;
}

function dateIsPast(expiresAt: number): boolean {
  return timeFormatter.dateIsPast(expiresAt);
}

export function needIsUnresolved(need: NeedDto, member: UserDto): boolean {
  return (
    !need.fulfilledAt &&
    (dateIsPast(need.expiresAt) || member?.memberStage?.key === 'independence')
  );
}
